<mat-form-field appearance="outline" subscriptSizing="dynamic" class="named-party-select">
  @if (label) {
    <mat-label>{{ label | translate }}</mat-label>
  }
  <input
    type="text"
    matInput
    autocomplete="off"
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    [placeholder]="'TRANS__IMPORT__NAMED_PARTY_SEARCH' | translate"
    (blur)="onBlur()"
  >
  @if (searching) {
    <mat-progress-spinner matSuffix mode="indeterminate" diameter="16"></mat-progress-spinner>
  }
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
    @for (option of options; track option.artifact_id) {
      <mat-option [value]="option">{{ option.name }}</mat-option>
    }
    @if (!searching && !options.length && inputControl.value) {
      <mat-option disabled>{{ 'TRANS__IMPORT__NAMED_PARTY_NO_HITS' | translate }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
